import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 27,
	viewBox: "0 0 34 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30.334 3.49935H17.0007L13.6673 0.166016H3.66732C1.81732 0.166016 0.350651 1.64935 0.350651 3.49935L0.333984 23.4993C0.333984 25.3493 1.81732 26.8327 3.66732 26.8327H30.334C32.184 26.8327 33.6673 25.3493 33.6673 23.4993V6.83268C33.6673 4.98268 32.184 3.49935 30.334 3.49935ZM30.334 23.4993H3.66732V3.49935H12.284L15.6173 6.83268H30.334V23.4993ZM17.0007 16.8327H20.334V20.166H23.6673V16.8327H27.0007V13.4993H23.6673V10.166H20.334V13.4993H17.0007V16.8327Z",
		fill: "#E8EAED"
	})
});
export { SvgFolderAdd as ReactComponent };
